import axios from 'axios';

export const defaultAuthHeaders = {
  Accept: '*/*',
  'Content-Type': 'application/x-www-form-urlencoded',
  scope: 'sales-journey-ms openid IdentityServerApi',
};

const AuthNetworkClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_LOGIN,
  headers: defaultAuthHeaders,
});

export default AuthNetworkClient;
